<template>
  <load v-if="loading" message="Carregando suas informações pessoais" />
  <div v-else class="account-component">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">{{ $t("Account") }}</h1>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <!-- <div class="col-12" v-if="!user.verified">
            <div class="alert alert-danger-gradient card-verify">
              <h4 class="text-white">{{ $t("Verify email") }}</h4>
              {{
                $t(
                  "Seu e-mail não foi verificado, então sua conta pode ficar restrita até ser verificada"
                )
              }}.
              <br />
              {{
                $t(
                  "Você pode solicitar a verificação da conta no botão a seguir, onde enviaremos um link para o seu e-mail para verificar a sua conta"
                )
              }}.
              <form @submit.prevent="requestVerify" class="mt-2">
                <button
                  class="btn btn-success btn-submit-verify mb-0"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-envelope-open-text"></i>
                  {{ $t("Solicitar verificação de e-mail") }}
                </button>
              </form>
            </div>
          </div> -->
          <div class="col-md-4">
            <b-card header-tag="header">
              <load
                v-if="loadingAvatar"
                message="Carregando imagem"
                mode="table"
              />
              <div v-else class="form-group mb-0">
                <b-img
                  :alt="$t('User avatar')"
                  :src="user.avatar ? user.avatar : $store.state.user.avatar"
                  center
                  class="mb-3 img-settings rounded-circle"
                />
                <b-form-file
                  :browse-text="$t('Browse')"
                  :placeholder="$t('Choose a file') + '...'"
                  @change="changeAvatar"
                  accept=".jpg, .png"
                  class="pointer"
                  id="user_avatar"
                  no-drop
                  ref="user_avatar"
                />
                <small>{{
                  $t(
                    "A imagem deve ser jpeg/png com no máximo 1000px de largura e 1MB de tamanho"
                  )
                }}</small>
              </div>
            </b-card>
          </div>
          <div class="col-md-8">
            <b-card header-tag="header">
              <template v-slot:header>
                <h3>
                  {{ $t("Personal information") }}
                </h3>
              </template>
              <form @submit.prevent="addItem" ref="addItem">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-bordered">
                      <tr>
                        <td>
                          FUNÇÃO NO SISTEMA:
                          <strong v-if="user.role_details">
                            {{ user.role_details.name }}
                          </strong>
                        </td>
                        <td>
                          UNIDADE:
                          <strong v-if="user.unidade">{{
                            user.unidade.nome
                          }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          CADASTRADO:
                          <strong v-if="item.created_at">
                            {{ item.created_at | formatDate() }}
                          </strong>
                        </td>
                        <td>
                          ATUALIZADO:
                          <strong v-if="item.created_at">
                            {{ item.updated_at | formatDate() }}
                          </strong>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <form-input
                    grid="6"
                    v-model="item.nome"
                    :required="true"
                    label="Nome"
                  />

                  <form-input
                    grid="3"
                    v-model="user.email"
                    :required="true"
                    label="E-mail"
                  />

                  <form-input
                    grid="3"
                    v-model="item.cpf"
                    v-mask="'###.###.###-##'"
                    label="CPF"
                  />

                  <form-input
                    grid="3"
                    label="Data de Nascimento"
                    v-model="data_nascimento"
                    placeholder="00/00/0000"
                    type="date"
                  />
                  <form-select
                    grid="3"
                    v-model="item.sexo"
                    :itens="$root.arrays.sexo"
                    :required="true"
                    placeholder="Selecione"
                    label="Sexo"
                  />

                  <form-input
                    grid="3"
                    v-model="item.telefone"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Telefone"
                  />
                  <form-input
                    grid="3"
                    v-model="item.whatsapp"
                    v-mask="'(##) #####-####'"
                    placeholder="(00) 00000-0000"
                    label="Whatsapp"
                  />
                  <form-input grid="6" v-model="item.profissao" label="Cargo" />
                  <form-select
                    grid="6"
                    v-model="item.escolaridade"
                    :itens="$root.arrays.tiposEscolaridadeTecnicos"
                    :required="true"
                    placeholder="Selecione"
                    label="Escolaridade"
                  />
                  <form-select
                    grid="6"
                    v-model="item.regime_trabalho"
                    :itens="$root.arrays.regimeTrabalhoTecnicos"
                    placeholder="Selecione"
                    label="Regime de Trabalho"
                  />
                  <form-select
                    grid="6"
                    v-model="item.carga_horaria"
                    :itens="$root.arrays.cargaHorariaTecnicos"
                    :required="true"
                    placeholder="Selecione"
                    label="Carga Horária"
                  />
                  <form-input
                    grid="6"
                    v-model="item.numero_registro"
                    label="Número de Registro"
                  />
                  <form-input
                    grid="6"
                    v-model="item.conselho_profissional"
                    label="Conselho Profissional"
                  />

                  <form-toggle
                    grid="12"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="item.send_mail"
                    label="Enviar notificações por e-mail"
                    :ajuda="
                      item.send_mail == 1
                        ? 'Todas as notificações serão enviadas por e-mail.' 
                        : 'O envio por e-mail está desabilitado. Apenas as notificações de PRAZOS continuaram sendo enviadas.'
                    "
                  />
                </div>

                <div class="float-right mt-3">
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                  </button>
                </div>
              </form>
            </b-card>
            <b-card header-tag="header">
              <template v-slot:header>
                <h3>{{ $t("Assinatura Digital") }}</h3>
              </template>
              <load
                v-if="loadingAssinatura"
                message="Carregando assinatura"
                mode="table"
              />
              <div v-else class="d-flex flex-column">
                <h4 class="d-block font-weight-bold">
                Use o campo abaixo para desenhar sua assinatura
                </h4>
                <div class="col-12 p-0">
                  <canvas
                    id="myCanvas2"
                    width="800"
                    height="150"
                    @mousedown="beginDrawing"
                    @mousemove="keepDrawing"
                    @mouseup="stopDrawing"
                    @touchstart.prevent="beginTouch"
                    @touchmove.prevent="moveTouch"
                    @touchend.prevent="stopTouch"
                  />
                </div>
                <div class="float-right mt-3">
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    @click="saveAssinatura"
                  >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                  </button>
                </div>
                <form-file
                  @submit="submitFile"
                  btn-text="Iniciar"
                  class="px-0 mt-5 "
                  :progress="progressCompleted"
                  label="Ou faça o upload da assinatura digital"
                  accept="image/png,image/jpeg,image/jpg"
                />
              </div>

              <div class="col-12 mt-5 px-0" v-if="assinatura_digital && !loadingAssinatura">
                <h4>Assinatura digital do técnico</h4>
                <img
                  :src="`${assinatura_digital}?v${d.getTime()}`"
                  class="mx-auto w-100"
                />
              </div>
            </b-card>
            <b-card header-tag="header">
              <template v-slot:header>
                <h3>{{ $t("Change password") }}</h3>
              </template>
              <form @submit.prevent="changePassword">
                <div class="form-group mb-3">
                  <label for="current_password"
                    >{{ $t("Current password") }}
                    <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    id="current_password"
                    required
                    type="password"
                    v-model="password.current_password"
                  />
                </div>
                <b-form-group class="mb-2" label-for="password">
                  <template v-slot:label class="d-block font-weight-bold">
                    {{ $t("Nova Senha") }}
                    <span class="text-danger">*</span>
                  </template>
                  <b-input-group>
                    <b-form-input
                      :type="passwordInput"
                      id="password"
                      v-model="password.password"
                    />
                    <b-input-group-append style="height: 35px">
                      <b-button
                        :title="$t('Show/Hide password')"
                        @click="showPassword"
                        class="px-2"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                      >
                        <i
                          class="fas fa-fw fa-eye"
                          v-if="passwordInput === 'password'"
                        />
                        <i class="fas fa-fw fa-eye-slash" v-else />
                      </b-button>
                      <b-button
                        :title="$t('Generate new password')"
                        @click="generatePassword"
                        class="px-2"
                        type="button"
                        v-b-tooltip.hover
                        variant="secondary"
                      >
                        <i class="fas fa-fw fa-sync" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div class="form-group">
                  <label for="password_confirmation"
                    >{{ $t("Confirm password") }}
                    <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    id="password_confirmation"
                    required
                    type="password"
                    v-model="password.password_confirmation"
                  />
                </div>
                <button
                  class="btn btn-success btn-submit-password mb-0 float-right"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="mdi mdi-content-save" />
                  {{ $t("Change password") }}
                </button>
              </form>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Account",
  metaInfo() {
    return {
      title: this.$i18n.t("Account"),
    };
  },
  mounted() {
    
    this.getUser();

    // Evitar o scroll do canvas no mobile
    const canvas = document.getElementById("myCanvas2");
    canvas.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
      },
      { passive: false }
    );
    canvas.addEventListener(
      "touchmove",
      (e) => {
        e.preventDefault();
      },
      { passive: false }
    );
  },
  data() {
    return {
      loadingSearchUnidade: false,
      loadingAvatar: false,
      loadingAssinatura: false,
      loading: true,
      user: {
        name: null,
        surname: null,
        email: null,
        verified: true,
        avatar: null,
      },
      password: {
        current_password: null,
        password: null,
        password_confirmation: null,
      },
      passwordInput: "password",
      item: [],
      files: [],
      progressCompleted: 0,
      data_nascimento: null,
      files: [],
      x: 0,
      y: 0,
      isDrawing: false,
      sending: false,
      canvas: null,
      assinatura_digital: null,
      d:new Date()
    };
  },
  methods: {

    beginTouch(e) {
      const touch = e.touches[0];
      const rect = e.target.getBoundingClientRect();

      this.x = touch.clientX - rect.left;
      this.y = touch.clientY - rect.top;

      this.isDrawing = true;
    },

    moveTouch(e) {
      if (!this.isDrawing) return;

      const touch = e.touches[0];
      const rect = e.target.getBoundingClientRect();

      const newX = touch.clientX - rect.left;
      const newY = touch.clientY - rect.top;

      this.drawLine(this.x, this.y, newX, newY);

      this.x = newX;
      this.y = newY;
    },

    stopTouch() {
      this.isDrawing = false;
      this.x = 0;
      this.y = 0;
    },

    saveAssinatura() {
      this.sending = true;
      const canvas = document.getElementById("myCanvas2");
      const files = canvas.toDataURL();
      console.log(this.dataURLtoFile(files, "assinatura.png"));
      this.submitFile(this.dataURLtoFile(files, "assinatura.png"));
    },
    submitFile(files) {
      this.files = files;
      let formData = new FormData();
      this.loadingAssinatura = true;
      formData.append("assinatura", this.files);
      formData.append("id", this.item.id);
      axios
        .post(`api/dashboard/tecnico/upload/assinatura`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          this.assinatura_digital = response.data;
          this.progressCompleted = 0;
          this.loadingAssinatura = false;
        });
    },
    getUser() {
      (this.loading = true),
        axios
          .post("/api/auth/user")
          .then((response) => {
            this.user = response.data.user;
            this.item = this.user.tecnico;
            this.data_nascimento = moment(
              this.user.tecnico.data_nascimento,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD");

            this.item.sexo = this.user.tecnico.sexo
              ? parseInt(this.user.tecnico.sexo)
              : null;
            this.assinatura_digital = this.user.tecnico.assinatura_digital;
       
            this.loading = false;
          }).finally(()=>{     var c = document.getElementById("myCanvas2");
    this.canvas = c.getContext("2d");})
          .catch(() => {
            this.loading = false;
            this.$router.push("/dashboard/home");
          });
    },
    requestVerify() {
      let ladda = Ladda.create(document.querySelector(".btn-submit-verify"));
      ladda.start();
      axios.post("api/account/verification").then((response) => {
        ladda.stop();
        swal.fire(this.$t("Ok"), response.data.data.message, "success");
      });
    },
    // Change user password
    changePassword() {
      let ladda = Ladda.create(document.querySelector(".btn-submit-password"));
      ladda.start();
      axios
        .post("api/account/password", this.password)
        .then((response) => {
          this.password = {
            current_password: null,
            password: null,
            password_confirmation: null,
          };
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .catch(() => {
          this.password = {
            password_confirmation: null,
          };
        });
    },
    // Change user avatar
    changeAvatar(e) {
      // Set formData
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      this.loadingAvatar = true;
      // Update image
      axios
        .post("api/account/avatar", formData, {
          header: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.user.avatar = URL.createObjectURL(e.target.files[0]);
          let avatar = document.getElementById("profile-img-avatar");
          avatar.src = this.user.avatar;
          this.loadingAvatar = false;
          this.$refs["user_avatar"].reset();
          this.$store.commit("setUser");

          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        });
    },
    addItem() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      this.item.email = this.user.email;
      this.item.role = this.user.role;

      if (this.data_nascimento) {
        this.item.data_nascimento = moment(this.data_nascimento).format(
          "DD/MM/YYYY"
        );
      }

      // Send request
      axios
        .put("api/dashboard/tecnicos/" + this.user.tecnico.id, this.item)
        .then((response) => {
          ladda.stop();
          this.$store.commit("setUser");
          this.getUser();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        });
    },
    // Show the password input
    showPassword() {
      if (this.passwordInput === "password") {
        this.passwordInput = "text";
      } else {
        this.passwordInput = "password";
      }
    },
    // Generate new password
    generatePassword() {
      this.password.password = window.GeneratePassword.generate({
        length: 8,
        numbers: true,
        symbols: false,
        excludeSimilarCharacters: true,
        strict: true,
      });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    drawLine(x1, y1, x2, y2) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.strokeStyle = "black";
      ctx.lineWidth = 1;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath();
    },
    beginDrawing(e) {
      this.x = e.offsetX;
      this.y = e.offsetY;
      this.isDrawing = true;
    },
    keepDrawing(e) {
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = e.offsetX;
        this.y = e.offsetY;
      }
    },
    stopDrawing(e) {
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = 0;
        this.y = 0;
        this.isDrawing = false;
      }
    },
  },
};
</script>
<style scoped="css">
#myCanvas2 {
  border: 1px solid grey;
}

.account-component {
  .card-verify {
    -webkit-transition: all 0.2s ease !important;
  }
}
</style>
